import { Error403Unauthorized } from '@app/components';
import { RIGHTS_IS_REGISTER, RIGHTS_RECORDS } from '@app/constants';
import { useAccessRights } from '@app/hooks';

import { RecordsList } from '@pages/Clients/Records/RecordsList.main';

export const Records = () => {
  const { hasUserRight: hasUserRightToRegister } = useAccessRights(
    RIGHTS_RECORDS,
    RIGHTS_IS_REGISTER
  );

  if (!hasUserRightToRegister) {
    return <Error403Unauthorized />;
  }

  return <RecordsList />;
};
